import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat',
  standalone: true // Set to true if using Angular 14+
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') return '';

    // Convert to number if it's a string
    let numberValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numberValue)) return '';

    // Standard Indian Numbering System formatting (2,00,000)
    // You can also use .toLocaleString('en-US') for International format
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(numberValue);
  }
}